import ApiUrl from "../../configTools/apiUrl";
const User = JSON.parse(localStorage.getItem("user-info"));

const CreateRoom = (id,setValues) =>{
    fetch(ApiUrl.API_URL_ChatRooms+"/"+id, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
      })
      .then(res=>res.json())
      .then(data =>{
        if(data.success){
            setValues(data.response)
        }
        else{
            alert('Message Api Failed');
        }
    });
}

const GetRoom = (setValues) =>{
    fetch(ApiUrl.API_URL_ChatRooms, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
      })
      .then(res=>res.json())
      .then(data =>{
        setValues(data)
    });
}


const Messages = (id,page,setValues) =>{
    fetch(ApiUrl.API_URL_ChatMessage+"/"+id+"/"+page, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
      })
      .then(res=>res.json())
      .then(data =>{
        if(data.success){
            setValues(data.responce)
        }
    });
}

const SendMessage = (body,setValue)=>{
    console.log(JSON.stringify(body));
    fetch(ApiUrl.API_URL_ChatMessage, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        },
        body: JSON.stringify(body)
      })
      .then(res=>res.json())
      .then(data =>{
        if(data.success){
            setValue('');
        }
    });
}

export default {CreateRoom,Messages,GetRoom,SendMessage}